'use strict';

import React from 'react';
import FaCheck from 'react-icons/lib/fa/check'
import FaExclamationTriangle from 'react-icons/lib/fa/exclamation-triangle'

class InputField extends React.Component {
  constructor(props) {
    super(props);
    // this.handleChange = this.handleChange.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.validate = this.validate.bind(this);

    this.state = {
      valid: this.validate(props)
    }
  }

  componentWillUpdate(nextProps) {
    if (nextProps.value == this.props.value) return;
    this.setState({
      valid: this.validate(nextProps)
    });
  }

  validate(nextProps) {
    if (this.props.type == 'email') {
      return this.validateEmail(nextProps.value)
    } else {
      return nextProps.value.length > 0
    }
  }

  validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
  }

  render() {
    const { errorMessage, ...rest } = this.props
    return (
    <div className={'site__form__input__container'} >
        <span className={this.props.value.length > 0 ? 'site__form__input__hint active' : 'site__form__input__hint'}>{ this.props.hint }</span>
        <span className={this.props.value.length > 0 ? 'site__form__input__label active' : 'site__form__input__label'}>{ this.props.label }</span>
        {this.props.type == 'area' &&
          <textarea {...rest} className="site__form__input"/>
        }
        {this.props.type != 'area' &&
          <input {...rest} className="site__form__input"/>
        }
        {this.state.valid &&
          <span className="success indicator"><FaCheck /></span>
        }
        {!this.state.valid &&
          <span className="error indicator"><FaExclamationTriangle /></span>
        }
        {!this.state.valid &&
          <span className="site__form__input__error">{ errorMessage }</span>
        }
    </div>
    );
  }
}

InputField.displayName = 'InputField';

// Uncomment properties you need
// InputField.propTypes = {};
// InputField.defaultProps = {};

export default InputField;



// WEBPACK FOOTER //
// ./src/components/InputField.js